/* eslint-disable camelcase */
import { DogItemInfos } from '@assets/rex/items/types/dog.item.info';
import Leash_Red_01 from './Leash_Red_01.png';
import Leash_Blue_01 from './Leash_Blue_01.png';
import Scarf_Red_01 from './Scarf_Red_01.png';
import Leash_AnimalPrint_01 from './Leash_AnimalPrint_01.png';
import Leash_Geometric_01 from './Leash_Geometric_01.png';
import Leash_Geometric_02 from './Leash_Geometric_02.png';
import Scarf_Bones_01 from './Scarf_Bones_01.png';
import Scarf_Bones_02 from './Scarf_Bones_02.png';
import Scarf_Rocker_01 from './Scarf_Rocker_01.png';
import Scarf_Yellow_01 from './Scarf_Yellow_01.png';

// TO-DO: fill names
const infos: DogItemInfos = {
  1201: { name: '', image: Leash_Red_01 },
  1202: { name: '', image: Leash_Blue_01 },
  1203: { name: '', image: Scarf_Red_01 },
  1204: { name: '', image: Leash_AnimalPrint_01 },
  1205: { name: '', image: Leash_Geometric_01 },
  1206: { name: '', image: Leash_Geometric_02 },
  1207: { name: '', image: Scarf_Bones_01 },
  1208: { name: '', image: Scarf_Bones_02 },
  1209: { name: '', image: Scarf_Rocker_01 },
  1210: { name: '', image: Scarf_Yellow_01 },
};

export default infos;
